<script lang="ts" setup>
    import { useRegisterSW } from "virtual:pwa-register/vue"
    import { ref, watch } from "vue"

    const intervalMS = 60 * 60 * 1000 // Vérifier toutes les heures
    const updated = ref(false)

    const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW({
        onRegisteredSW(swUrl, registration) {
            if (!registration) return
            setInterval(async () => {
                if (registration.installing || !navigator) return
                if ("connection" in navigator && !navigator.onLine) return
                const resp = await fetch(swUrl, {
                    cache: "no-store",
                    headers: { cache: "no-store", "cache-control": "no-cache" },
                })
                if (resp.status === 200) await registration.update()
            }, intervalMS)
        },
    })

    watch(needRefresh, (val) => {
        if (val) {
            updateServiceWorker()
            updated.value = true
        }
    })
</script>

<template>
    <v-snackbar v-model="updated" color="success" :timeout="5000">
        L'application a été mise à jour.
        <template v-slot:actions>
            <v-btn variant="text" @click="updated = false"> Fermer </v-btn>
        </template>
    </v-snackbar>
</template>
